import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { healthCyclesAPI } from '../../services/api'
import { formatDate } from './cycleStatus'
import { readableValue } from './cycleOverviewFormat'

// VH-227: confirmed chat changes with the message they came from and before/after.
export function CycleHistory({ cycleId }) {
  const { t, i18n } = useTranslation()
  const { data: entries = [], isLoading } = useQuery({
    queryKey: ['healthCycleHistory', cycleId],
    queryFn: () => healthCyclesAPI.history(cycleId),
    select: (response) => response.data ?? [],
    enabled: !!cycleId,
  })

  return (
    <section className="card" aria-label={t('healthCycle.history.title')}>
      <div className="card-body">
        <h3 className="text-sm font-semibold text-gray-900 mb-3">{t('healthCycle.history.title')}</h3>
        {isLoading ? (
          <p className="text-sm text-gray-500">{t('common.loading')}</p>
        ) : entries.length === 0 ? (
          <p className="text-sm text-gray-500">{t('healthCycle.history.empty')}</p>
        ) : (
          <ol className="space-y-3">
            {entries.map((entry) => (
              <li key={entry.change_set_id} className="border-l-2 border-purple-300 pl-3">
                <p className="text-xs text-gray-500">
                  {formatDate(entry.confirmed_at, i18n.language)}
                  {entry.version_number != null && ` · ${t('healthCycle.versions.label', { number: entry.version_number })}`}
                </p>
                {entry.message && <p className="text-sm text-gray-800 italic">“{entry.message}”</p>}
                <ul className="mt-1 text-xs text-gray-700 space-y-0.5">
                  {entry.operations.map((op, i) => (
                    <li key={op.id ?? i}>
                      {t(`healthCycle.changeSet.ops.${op.op}`, op.op || '')}: {(readableValue(op.before) ?? t('healthCycle.compare.changed'))} → {(readableValue(op.after) ?? t('healthCycle.compare.changed'))}
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ol>
        )}
      </div>
    </section>
  )
}

export default CycleHistory
